import { ComponentType } from '@angular/cdk/portal';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { filter } from 'rxjs/operators';
import { CostElementsListComponent } from 'src/app/cost-elements/cost-elements-list/cost-elements-list.component';
import { MenuEventService } from 'src/app/layers/actions/map-actions/menu-event.service';
import { MapDrawService } from 'src/app/shared/components/map/map-draw.service';
import { WindowService } from 'src/app/shared/components/window/window.service';
import { environment } from 'src/environments/environment';
import { SimulationArchitectureComponent } from '../simulation-architecture/simulation-architecture.component';
import { SimulationAttenuationComponent } from '../simulation-attenuation/simulation-attenuation.component';
import { SimulationDebugParamsComponent } from '../simulation-debug-params/simulation-debug-params.component';
import { SimulationTopologyComponent } from '../simulation-topology/simulation-topology.component';
import { SimulationValidationComponent } from '../simulation-validation/simulation-validation.component';
import { SimulationQuery } from '../state/simulation.query';
import { SimulationService } from '../state/simulation.service';

@Component({
  selector: 'app-simulation-detail',
  templateUrl: './simulation-detail.component.html',
  styleUrls: ['./simulation-detail.component.scss']
})
export class SimulationDetailComponent implements OnInit, OnDestroy {

  simulation$ = this.simulationQuery.active$;

  coverageMode$ = this.simulationQuery.coverageMode$;

  parametersErrors$ = this.simulationQuery.parametersErrors$;

  production = environment.production;

  stepsStatus = {
    coverage: false,
    topology: false,
    architeture: false,
    attenuation: false,
    materials: false,
    validation: false
  };

  constructor(
    private simulationQuery: SimulationQuery,
    private windowService: WindowService,
    private drawService: MapDrawService,
    private menuEventService: MenuEventService,
    private simulationService: SimulationService
  ) { }

  ngOnInit(): void {
    this.drawService.disable();
    this.menuEventService.active = false;
    this.updateSteps();
    this.drawAreas();
  }

  ngOnDestroy(): void {
    this.drawService.clear();

    this.menuEventService.active = true;
    this.simulationService.clearParametersErrors();
    this.windowService.closeAll();
  }

  editCoverageArea(): void {
    this.simulationService.setCoverageMode(true);
  }

  openTopology(): void {
    const title = $localize`NETWORK - TOPOLOGY`;
    this.open(title, SimulationTopologyComponent, 'TOPOLOGY');
  }

  openArchitecture(): void {
    const title = $localize`NETWORK - ARCHITECTURE`;
    this.open(title, SimulationArchitectureComponent, 'ARCHITECTURE');
  }

  openAttenuation(): void {
    const title = $localize`NETWORK - ATTENUATION`;
    this.open(title, SimulationAttenuationComponent, 'ATENUATION');
  }

  openMaterials(): void {
    const titleConfig = $localize`MATERIALS`;
    this.windowService.open({ title: titleConfig, componentType: CostElementsListComponent, help: 'MATERIALS' });
  }

  debugParameters(): void {
    const titleConfig = $localize`DEBUG PARAMETERS`;
    this.windowService.open({ title: titleConfig, componentType: SimulationDebugParamsComponent });
  }

  validate(): void {
    const title = $localize`NETWORK - VALIDATE`;
    this.open(title, SimulationValidationComponent, 'NETWORK_VALIDATION');
  }

  private open(title: string, componentType: ComponentType<any>, help?: string) {
    this.windowService.open({
      title,
      componentType,
      help,
      config: {
        data: this.simulationQuery.getActive()
      }
    });
  }

  private updateSteps() {
    this.simulation$
      .pipe(filter(s => !!s))
      .subscribe(simulation => {

        if (simulation.areas_definition?.length > 0) {
          this.stepsStatus.coverage = true;
        }

        const { parameters } = simulation;

        if (parameters) {

          if (parameters.horizontal_access_per_pon) {
            this.stepsStatus.topology = true;
          }
          if (parameters.central_office_settings?.internal_cable_type) {
            this.stepsStatus.architeture = true;
          }
          if (parameters.attenuation_settings) {
            this.stepsStatus.attenuation = true;
          }
          if (parameters.cost_elements?.length > 0) {
            this.stepsStatus.materials = true;
          }
        }

      });
  }

  private drawAreas(): void {
    const simulation = this.simulationQuery.getActive();

    if (simulation.areas_definition) {
      simulation.areas_definition.forEach(a => {
        this.drawService.addArea(a);
      });
    }
  }
}
